import React from 'react';

import PhoneVerification from '@swf/components/PhoneVerification/PhoneVerification';
import Translation from '@swf/components/Translation/Translation';

import Container from '../../../Container/Container';

import { TXTWCL_Mobile_Number_Verification } from './RMFPhoneVerification.messages.json';
import styles from './RMFPhoneVerification.scss';

const RMFPhoneVerification: React.FC = () => (
  <Container
    page={RMFPhoneVerification}
    headerProps={{
      title: <Translation {...TXTWCL_Mobile_Number_Verification} />
    }}
    pageClassName={styles.validationPage}
  >
    <PhoneVerification.ValidateCode first />
  </Container>
);

RMFPhoneVerification.displayName = 'RMFPhoneVerification';

export default RMFPhoneVerification;
